import React, { FC, memo, useCallback } from 'react';
import { FnTagVariants } from './constants';
import { TAGS } from './styles';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  variant?: FnTagVariants;
  data: Record<string, unknown>;
  labelProp: string;
  onClick: (data: Record<string, unknown>) => void;
}

const FnTag: FC<Props> = ({ variant = FnTagVariants.Default, data, labelProp, onClick }) => {
  const TypedTag = TAGS[variant];
  const handleClick = useCallback(() => onClick(data), [data]);

  return <TypedTag text={String(data[labelProp])} endIcon={<FontAwesomeIcon icon={faTimes} />} onClick={handleClick} />;
};

export default memo(FnTag);
